import { render, staticRenderFns } from "./Statute.vue?vue&type=template&id=25fb0674&"
import script from "./Statute.vue?vue&type=script&lang=js&"
export * from "./Statute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports